import { Box, CircularProgress, Typography } from '@mui/material';
import { ISetupPdfMessages } from '../../../../types/setupPDFTypes';

import React from 'react';
import { styles } from './LoadingSpinner.styles';

export const LoadingSpinner = ({ messages }: { messages: ISetupPdfMessages }) => {
  return (
    <Box sx={styles.loadingSpinner}>
      <CircularProgress />
      <Typography>{messages.loading}</Typography>
    </Box>
  );
};
